/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const invAnalyticsServices = {
	gateway,
	fetchInvAnalysisGraph,
	exportInvAnalysisList,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CHART_DATA':
			return fetchInvAnalysisGraph({
				req,
			});
		case 'LIST_DATA':
			return fetchInvAnalysisList({
				req,
			});
		default:
			break;
	}
	return new Promise();
}
function fetchInvAnalysisGraph({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.INV_ANALYTICS, requestOptions).then(
		handleResponse
	);
}

function fetchInvAnalysisList({ req }) {
	const { params = {} } = req;
	// console.log('passed req', {
	// req,
	// });
	// const url = toQueryStringURL(endpoints.QUALITY_ANALYTICS_LIST, params);
	const url = toQueryStringURL(endpoints.INV_ANALYTICS_LIST, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
			// clientID: 52,
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	// return mockQAList(requestOptions);
	return fetch(url, requestOptions).then(handleResponse);
	// return mockQAList(url, requestOptions);
}

// exportInvAnalysisList;
function exportInvAnalysisList(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.INV_ANALYTICS_EXPORT, requestOptions);
}

export default invAnalyticsServices;
